import { Component, OnInit, ViewChild } from '@angular/core';
import { MatInput } from "@angular/material";
import { saveAs } from "file-saver";
import { DatePipe } from "@angular/common";
import { VernostServiceService } from "../../../../services/vernost-service.service";
import { Router } from "@angular/router";
@Component({
  selector: 'app-credit-shell-report',
  templateUrl: './credit-shell-report.component.html',
  providers: [DatePipe]
})
export class CreditShellReportComponent implements OnInit {
  screentitle: string = "Credit Shell Report";
  uid: string;
  search_details;
  isJpNumber: boolean = false;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  typeOfRedem: any;
  IsEmptyVal: boolean = false;
  isOrd: boolean = false;
  mydate:Date;
  typeOfRedemption: any = "A";

  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;
  final: any;
  noresult: string;
  loader: boolean = false;
  searchlist: boolean = true;
  totalItems: number = 1;
  p: number = 1;
  constructor(private vernostService: VernostServiceService,private router: Router,private datePipe: DatePipe) { }

  ngOnInit() {
    this.mydate = new Date();
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.search_details = {
      jp_number: "",
      order_id: "",
      from_date: "",
      to_date: ""
    };
  }
  ngAfterContentInit() {
    this.search_details.from_date = new Date();
    this.search_details.to_date = new Date();
    this.final = this.search_details.from_date.setDate(
      this.search_details.to_date.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyVal = true;
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }
  selectTypeOfRedemption(type) {
    this.typeOfRedemption = type;
  }
  jpNumberValidation1() {
    var JPNo = this.search_details.jp_number;
    if (JPNo.length > 0) {
      if (JPNo.length < 9) {
        document.getElementById("JpErr").innerHTML =
          "Please enter the correct JP number.";
        document.getElementById("JpErr").style.color = "red";
        this.isJpNumber = true;
      } else {
        document.getElementById("JpErr").innerHTML = "";
        this.isJpNumber = false;
      }
    }
  }
  orderValidation() {
    var regex = /^[A-Za-z0-9_]+$/;

    var JPNo = this.search_details.order_id;
    if (JPNo != "" && regex.test(JPNo) == false) {
      document.getElementById("orErr").innerHTML =
        "Only Alphabets and Numbers allowed";
      document.getElementById("orErr").style.color = "red";
      this.isOrd = true;
    } else {
      document.getElementById("orErr").innerHTML = "";
      this.isOrd = false;
    }
  }
  orderValidation1() {
    var JPNo = this.search_details.order_id;
    if (JPNo.length > 0) {
      if (JPNo.length < 14) {
        document.getElementById("orErr").innerHTML =
          "Please enter valid Booking Reference No ";
        document.getElementById("orErr").style.color = "red";
        this.isOrd = true;
      } else {
        document.getElementById("orErr").innerHTML = "";
        this.isOrd = false;
      }
    }
  }
  reset3() {
    this.input3.value = "";
    this.search_details.from_date = "";
    this.search_details.to_date = "";
    this.final = "";
    this.isEmpty();
  }
  reset4() {
    this.input4.value = "";
    this.search_details.to_date = "";
    this.isEmpty();
  }
  isEmpty() {
    if (
      this.search_details.jp_number == "" &&
      this.search_details.order_id == "" &&
      this.search_details.from_date == "" &&
      this.search_details.to_date == "" 
    ) {
      this.IsEmptyVal = false;
    } else {
      if((this.search_details.from_date != "" &&
      this.search_details.to_date == "") ){
        this.IsEmptyVal = false;  
      }else{
        this.IsEmptyVal = true;
      }
    }
  }
  
  incresedate() {
    this.search_details.to_date = "";
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    var tam = new Date(tomorrow);

    this.final = tam.setDate(tam.getDate());
    this.final = new Date(this.final);
  }
  checkStatus(val) {
    if(val == 1 || val == '1'){
      this.search_details.from_date ='';
      // this.search_details.from_date =='';
    }
    this.mydate = this.search_details.from_date;
    if(
      this.search_details.from_date != "" &&
      this.search_details.to_date != ""
      ){
        this.IsEmptyVal = true;
    }else{
      this.IsEmptyVal = false;
    } 
  }
  validData(val){
    this.noresult = "";
    if (
      this.isJpNumber == false &&
      this.isOrd == false &&
      ((this.search_details.from_date != "" && this.search_details.to_date != "") || this.search_details.order_id.length > 0 || this.search_details.jp_number.length > 0 || (this.search_details.from_date != null && this.search_details.to_date != null))
    ) {
      this.loader = true;
      this.searchlist = false;
      this.search_details.from_date = this.datePipe.transform(
        this.search_details.from_date,
        "yyyy-MM-dd"
      );
      this.search_details.to_date = this.datePipe.transform(
        this.search_details.to_date,
        "yyyy-MM-dd"
      );
      var from_date = this.search_details.from_date;
      var to_date = this.search_details.to_date;
      var jp_number = "";
      if (this.typeOfRedemption == "A" && this.search_details.jp_number.length > 0) {
        jp_number = this.search_details.jp_number;
      }
      if (this.typeOfRedemption == "R" && this.search_details.jp_number.length > 0) {
        jp_number = "00" + this.search_details.jp_number;
      }
      var BOOKING_REF_NO = (this.search_details.order_id.toString().length <= 15 ? this.search_details.order_id.slice(4, this.search_details.order_id.length) : this.search_details.order_id);
      var data = {
        from_date:  from_date,
        to_date: to_date,
        jp_number: jp_number,
        order_id: BOOKING_REF_NO,
        pagination: this.p,
        typeOfRedemption: this.typeOfRedemption,
        type : val
      };
      return data;
    }else{
      console.log("ERR");
      
      this.IsEmptyVal = false;
      return null;
    }
  }
  async searchData() {
    var data = this.validData('report');
    if (data != null) {
      this.vernostService.getCreditShellReport(data).subscribe(async response => {
        var Data = response;
        this.totalItems = Data[0].count;
        this.search_result_list = Data[0].result;
        this.typeOfRedem = this.typeOfRedemption;

        for (var i = 0; i < this.search_result_list.length; i++) {
          this.search_result_list[i].PARENT_BOOKING_REF_NO = this.search_result_list[i].PARENT_BOOKING_REF_NO != null ? (this.search_result_list[i].PARENT_BOOKING_REF_NO.toString().length < 12 ? "JPUB" + this.search_result_list[i].PARENT_BOOKING_REF_NO : this.search_result_list[i].PARENT_BOOKING_REF_NO) : 'NA';
        }

        var Search_Details = [];
        this.order_Id_list = [];
        for (var j = 0; j < this.search_result_list.length; j++) {
          Search_Details.push(this.search_result_list[j]);
        }
        this.search_detail_list = Search_Details;
        if (
          this.search_detail_list.length == 0 ||
          this.search_detail_list == undefined ||
          this.search_detail_list == ""
        ) {
          this.noresult = "Result Not Found";
          this.loader = false;
        } else {
          this.loader = false;
        }
      });
    }
  }

  async getReprt() {
    var data = this.validData('download')
    this.vernostService.getCreditShellReport(data).subscribe(result => {
        this.noresult = "";
        if (result['size'] != 0) {
          saveAs(result, "CreditShellReport.csv");
        } else {
          this.noresult = "Result Not Found";
        }
        this.loader = false;
      },
      err => {}
    );
  }
  pageCount(count) {
    this.p = count;
    this.searchData();
    // console.log("P:::", this.p);
  }
}
